import { makeAutoObservable } from 'mobx';
import { ComboBox, IComboBoxOption } from '@fluentui/react';
import { observer } from 'mobx-react';
import { FieldType, IEntityColumn } from '../../../API';

export class EntityMultiColumnSelectorState {

	public availableFields:IEntityColumn[] = [];
	public selectedFields: string[] = [];
	onChange: (fields: string[]) => void;
	filterType: FieldType;
	multi: boolean;
	
	constructor(
		selected:string[],
		filterType:FieldType,
		onChange: (fields:string[]) => void,
		multi:boolean = true
	) {
		this.onChange = onChange;
		this.filterType = filterType;
		this.multi = multi;
		this.selectedFields = selected;
		makeAutoObservable(this);
	}

	public setAvailableFields(availableFields:IEntityColumn[]) {

		if(this.filterType !== FieldType.Invalid) {
			this.availableFields = availableFields.filter(f => f.fieldType === this.filterType);
		} else {
			this.availableFields = availableFields;
		}

		this.availableFields = this.availableFields.sort((f1, f2) => f1.displayName > f2.displayName ? 1 : -1);
	}

	public setSelectedFields(fields:string[]) {
		this.selectedFields = fields;
	}
 
	public selectField(id: string, selected: boolean) {
		if(selected) {
			this.selectedFields = this.selectedFields.concat([id]);
		} else {
			this.selectedFields = this.selectedFields.filter(f => f !== id);
		}

		this.onChange(this.selectedFields);
	}
}

function EntityMultiColumnSelector({
	state
}: {
	state: EntityMultiColumnSelectorState;
}) {
	
	const options: IComboBoxOption[] = state.availableFields.map(f => {
		return {
			key: f.id,
			text: `${f.displayName}`
		};
	});

	return (
		<ComboBox defaultSelectedKey={state.selectedFields} options={options} multiSelect={state.multi} onChange={((_,o) => { 
			let key = (o?.key || '').toString();
			if(key) {
				state.selectField(key, !!o?.selected) 
			}
		})}/>
	);
}

export default observer(EntityMultiColumnSelector);
